export default __webpack_public_path__ + "static/media/news.561517b1.svg";